import React from 'react'
import { useLocalize } from '@zooz/react-localize'
import { Link } from 'react-router-dom'

import Locations from '../../../../helpers/tools/locations'
import language from './language'

import style from './style.scss'

interface PopUpContentProps {
  isActivationPermitted: boolean
}

export const PopUpContent: React.FC<PopUpContentProps> = ({ isActivationPermitted }) => {
  const { t } = useLocalize()
  if (isActivationPermitted) {
    return (
      <div className={style['popup-text']}>
        {language.activationPermitted(t)}
        <Link className={style['a-tag']} to={Locations.activationSelectPlanPage()}>{language.goToActivation(t)}</Link>
      </div>
    )
  }
  return (
    <div className={style['popup-text']}>
      {language.activationNotPermitted(t)}
    </div>
  )
}
